// extracted by mini-css-extract-plugin
module.exports = {"description":"referral_description__XtgTU"};